import React, { useState } from "react";
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
  UncontrolledDropdown,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { deleteVigilant } from "../../../helpers/api/security";
import { SUCCESS_RESPONSE } from "../../../helpers/codeResponses/codes";
import { Toast } from "../../UI/toast/Toast";
import handleErrorMessage from "../../../helpers/errors/handleErrorMessage";
import { useHistory } from "react-router-dom";
import Avatar from "../../common/Avatar";
import { Or } from "../../UI/preloading/PreloadState";
import moment from "moment";

const VigilantRow = ({ role, auth_id, created_at, people, username }) => {
  const { address, dni, firstname, image, lastname, phone } = people;
  const history = useHistory();
  const [submitting, setSubmitting] = useState(false);
  const [collapseOne, collapseOneOpen] = useState(false);

  const handleModal = () => (
    <Modal isOpen={collapseOne} data-testid="modal">
      <ModalHeader>Confirmación</ModalHeader>
      <ModalBody>
        <p className="mb-0 font-weight-bold fs--1">
          ¿Está seguro de eliminar a este vigilante? Esta información no puede
          ser cambiada posteriormente. Tendrá qué registrar otro vigilante en un
          futúro.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => collapseOneOpen(!collapseOne)}>Cancelar</Button>
        <Button
          data-testid="submit-button"
          color="primary"
          disabled={submitting}
          type="submit"
          onClick={deleteV}
        >
          Sí, eliminar {submitting && <Spinner color="light" size="sm" />}
        </Button>
      </ModalFooter>
    </Modal>
  );

  const deleteV = () => {
    setSubmitting(true);
    deleteVigilant(auth_id)
      .then(({ code }) => {
        if (code === SUCCESS_RESPONSE.OK) {
          Toast.fire({
            type: "success",
            title: `Vigilante eliminado exitosamente.`,
          });
          history.push("/dashboard/security/vigilants");
        }
      })
      .catch((error) => handleErrorMessage(error))
      .finally(() => setSubmitting(false));
  };

  return (
    <>
      <tr>
        <td className="text-center align-middle">
          <Avatar src={image || undefined} />
        </td>
        <td className="text-center align-middle">
          <b>{dni}</b>
        </td>
        <td className="align-middle">
          {firstname} {lastname}
        </td>
        <td className="text-center align-middle">
          {phone || "No registrado"}
        </td>
        <td className="text-center align-middle">
          {moment(created_at).format("DD-MM-YYYY")}
        </td>
        <td className="align-middle text-center">
          <UncontrolledDropdown direction="left">
            <DropdownToggle color="falcon-default" size="sm">
              <FontAwesomeIcon icon="ellipsis-h" />
            </DropdownToggle>
            <DropdownMenu positionFixed={true}>
              <DropdownItem
                onClick={() =>
                  history.push(`/dashboard/security/vigilants/${auth_id}`, {
                    vigilant: {
                      firstname,
                      lastname,
                      dni,
                      phone,
                      address,
                      image,
                      username,
                    },
                  })
                }
              >
                Ver detalle
              </DropdownItem>
              <Or cond={role}>
                <Or value="manager">
                  <DropdownItem
                    onClick={() =>
                      history.push(
                        `/dashboard/security/vigilants/${auth_id}/edit`,
                        {
                          vigilant: {
                            firstname,
                            lastname,
                            dni,
                            phone,
                            address,
                          },
                        }
                      )
                    }
                  >
                    Editar
                  </DropdownItem>
                </Or>
                <Or value="manager">
                  <DropdownItem divider />
                </Or>
                <Or value="manager">
                  <DropdownItem
                    className="text-danger"
                    onClick={() => collapseOneOpen(true)}
                  >
                    Desactivar vigilante
                  </DropdownItem>
                </Or>
              </Or>
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
      </tr>
      {handleModal()}
    </>
  );
};

export default VigilantRow;
